
export const environment = {
  production: true,
  routerBasename: null,
  pageTitle: 'Storyverse (Staging)',
  serviceAddress: '',
  userServiceApi: 'metamask',
  adminApi: 'mock',
  metadataApi: 'rest',
  plotsApi: 'mbaas',
  analyticsApi: 'amp',
  chainalysisApi: 'mock',
  navbarApi: 'navbar',
  walletApi: 'navbar',
  writerApi: 'navbar',
  saleApi: 'navbar',
  ampKey: '97010c5f52294f2dc9214ac0cdf97a2a',
  restMetadataUrl: 'https://meta.alpha.pnk.one/a',
  openSeaUrl: 'https://testnets.opensea.io',
  openSeaContract: '0x17551c9e53a1d7345ffa7d6ed00040232cbf6858',
  introUrl: 'https://intro.storyverse.pnk.one',
  chainalysisUrl: 'https://api.chainalysis.com/api/kyt/v1/',
  chainalysisApiKey: 'e9a2a04ab126e27b40d67809fc8f3f4245cbf8b4934ec15a12933bd203a910be',
  mockLoadingMs: 500,
  forcePageState: null,
  mapsUrl: 'https://maps.alpha.pnk.one',
  createUrl: 'https://create.beta.pnk.one/index.html',
  viewUrl: 'https://view.beta.pnk.one/index.html',
  ethNetwork: 'rinkeby',
  serviceProxyUrl: 'https://blockchain.alpha.pnk.one',
  plotsBaseURI: 'https://meta.alpha.pnk.one/a',
  persistStoryServerPrefix: 'https://pipeline.beta.pnk.one/story/',
  persistPlotServerPrefix: 'https://pipeline.beta.pnk.one/plot/',
  captionContestUrl: 'https://intro.storyverse.pnk.one/caption-contest/alpha/',
  passthroughParams: ['resetPlot'],
  appUrlOverride: false,
  templateApiPrefix: 'https://pipeline.beta.pnk.one/templates/visible/',
  assetsApiPrefix: 'https://pipeline.beta.pnk.one/assets/',
  foundersPassContract: '0x8c2220db0CCB009Da045744e40e1aCF54A51a478',
}
